import React, { useEffect } from 'react';
import './Home.css';
import gifDemo from '../assets/LogoHypothesisGamesGIFPhotoshop.gif';

function Home() {
  let touchStartX = 0;
  let touchStartY = 0;

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.deltaY > 0) { // Scrolleando hacia abajo
        window.location.href = '/about';
      }
    };

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchEnd = (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      
      const deltaX = touchStartX - touchEndX;
      const deltaY = touchStartY - touchEndY;

      // Determinar si el movimiento es más horizontal que vertical
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        // Solo detectar movimiento hacia la derecha
        if (deltaX > 50) { // Umbral de 50px
          window.location.href = '/catalog';
        }
      } else {
        // Movimiento vertical
        if (Math.abs(deltaY) > 50 && deltaY > 0) {
          window.location.href = '/about';
        }
      }
    };

    window.addEventListener('wheel', handleWheel);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <section className="home-container">
      <div className="hero-background">
        <img src={gifDemo} alt="Fondo animado" className="background-gif" />
      </div>

      <div className="hero-content">
        <a 
          href="/about" 
          className="hero-link pulse-animation"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = '/about';
          }}
        >
          come explore endless possibilities
        </a>
      </div>
    </section>
  );
}

export default Home;